<template>
  <div
      v-if="visible"
      class="fixed top-0 left-0 z-[9998] grid h-screen w-screen bg-black bg-opacity-70 px-8 py-4 overflow-y-auto"
      @click.self="onBackgroundClick"
  >
    <ac-card
        class="relative z-[9999] m-auto rounded border border-[#ccc] bg-blue-employer-modal py-4 px-6 lg:min-w-65p"
    >
      <div class="flex flex-col gap-4">
        <p class="text-2xl text-white font-bold">Are you an employer or a candidate?</p>
        <p class="text-sm lg:text-base text-[#dcdcdc] font-normal">
          You're <strong>one click away</strong> from your list of agencies.
          With this information, we'll give you the options that are most relevant to your needs.
        </p>
        <div class="flex flex-col lg:flex-row justify-around gap-8 py-6 px-8">
          <EmployerModalCard
              title="I'm a candidate, looking for work"
              description="We'll match you with the best agencies who can help you with your jobsearch."
              buttonText="Find work now"
              @onCloseModal="onContentCloseClick"
              @onClick="onSearch('cnd')"
              :buttonHref="searchURLFor('cnd')"
          />
          <EmployerModalCard
              title="I'm an employer, looking for staff"
              description="We'll match you with the best agencies to help you with your hiring needs."
              buttonText="Find staff now"
              @onCloseModal="onContentCloseClick"
              @onClick="onSearch('emp')"
              :buttonHref="searchURLFor('emp')"
          />
        </div>
      </div>
    </ac-card>
  </div>
</template>

<script>
import AcCard from 'Components/AcCard.vue';
import EmployerModalCard from 'Components/Cards/EmployerModalCard.vue';
import IconCross from 'Components/Icons/IconCross';
import InputButton from "Components/InputButton.vue";
import validates, { validators } from "Mixins/validates";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: 'EmployerOptionSelectModal',
  components: {
    InputButton,
    AcCard,
    IconCross,
    EmployerModalCard
  },
  mixins: [ validates ],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    industry: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('search', ['currentLocationOption', 'searchQuery']),
  },
  methods: {
    ...mapMutations('search', ['setParameter']),
    onBackgroundClick() {
      this.$emit('onBackgroundClick');
    },
    onContentClick() {
      this.$emit('onContentClick');
    },
    onContentCloseClick() {
      this.$emit('onContentCloseClick');
    },
    searchURLFor(type) {
      let p = { ...this.searchQuery, emp_cand: type, industry: this.industry };
      let url = this.$router.resolve({
        name: 'search',
        query: p
      });

      return encodeURI(url.href);
    },
    onSearch(emp_cand) {
        this.onContentCloseClick();
        this.$emit('onSearch', emp_cand);
    },
  },
};
</script>
